import React from 'react';
import { PropTypes } from 'prop-types';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import { darken, saturate, readableColor } from 'polished';
import Loader from '../loader/Loader';

const Button = styled.button`
  margin-top: ${({ noTopMargin }) => noTopMargin || '10px'};
  background-color: ${({ success, theme, customButton, background }) =>
    success ? theme.success : customButton ? background : theme.buttonPrimary};
  border: none;
  transition: 250ms;
  height: ${({ fullHeight }) => (fullHeight ? '100%' : '40px')};
  width: ${props => (props.fullWidth ? '100%' : '121px')};
  outline: 0;
  cursor: ${props => (props.disabled ? 'default' : 'pointer')};

  background: ${({ disabled, success, theme }) => disabled && !success && theme.disabledColor};

  &:hover {
    background-color: ${({ theme, background, disabled }) =>
      !disabled && saturate(0.15, background || theme.buttonPrimary)};
  }

  &:focus {
    outline: thin solid
      ${({ theme, background }) => darken(0.05, background || theme.buttonPrimary)};
    color: ${({ theme, background }) => readableColor(background || theme.buttonPrimary)};
    border: thin solid white;
    background: ${({ theme, background }) => saturate(0.15, background || theme.buttonPrimary)};
  }

  &:active {
    background-color: ${({ theme, background }) => darken(0.01, background || theme.buttonPrimary)};
    box-shadow: none;
    color: ${({ theme, background }) =>
      readableColor(darken(0.01, background || theme.buttonPrimary))};
  }

  @media only screen and (max-width: 768px) {
    width: 100%;
  }
`;

const ButtonText = styled.span`
  height: 23px;
  color: #fff;
  font-size: ${props => (props.theme.buttonFontSize ? props.theme.buttonFontSize : '16px;')};
  font-weight: ${props => (props.theme.buttonFontSize ? 'bold' : '500;')};
  line-height: 23px;
  text-align: center;
`;

const SubmitButton = ({
  label,
  fullWidth,
  fullHeight,
  success,
  successLabel,
  formSubmitting,
  customButton,
  background,
  disabled,
  onClick,
  noTopMargin,
}) => (
  <Button
    success={success}
    fullWidth={fullWidth}
    fullHeight={fullHeight}
    noTopMargin={noTopMargin}
    customButton={customButton}
    background={background}
    onClick={onClick}
    type="submit"
    disabled={formSubmitting || success || disabled}
  >
    <ButtonText>
      {formSubmitting ? (
        <Loader color="#FFF" />
      ) : (
        <FormattedMessage id={success && successLabel ? successLabel : label} />
      )}
    </ButtonText>
  </Button>
);

SubmitButton.propTypes = {
  label: PropTypes.string,
  fullWidth: PropTypes.bool,
  fullHeight: PropTypes.bool,
  customButton: PropTypes.bool,
  formSubmitting: PropTypes.bool,
  success: PropTypes.bool,
  successLabel: PropTypes.string,
  background: PropTypes.string,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  noTopMargin: PropTypes.bool,
};

SubmitButton.defaultProps = {
  label: 'button',
  background: null,
  fullWidth: false,
  fullHeight: false,
  formSubmitting: true,
  customButton: false,
  success: false,
  successLabel: null,
  disabled: false,
  onClick: () => null,
  noTopMargin: false,
};

export default SubmitButton;
